<template>
  <div :class="bem()" />
</template>

<script>
import { create } from '../utils'

export default create({
  name: 'space'
})
</script>

<style lang="scss" src="./index.scss"></style>
